import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=2e4a4c6c&scoped=true&"
import script from "./uploadData.vue?vue&type=script&lang=js&"
export * from "./uploadData.vue?vue&type=script&lang=js&"
import style0 from "./uploadData.vue?vue&type=style&index=0&id=2e4a4c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a4c6c",
  null
  
)

export default component.exports